import { createFileRoute } from '@tanstack/react-router';
import { Dashboard } from '../../organisms/Dashboard';
import z from 'zod';

const ZodSearchParams = z.object({
  verifyEmail: z.string().optional()
});

export const Route = createFileRoute('/_authenticated/')({
  component: RouteComponent,
  validateSearch: (search) => ZodSearchParams.parse(search) 
});

function RouteComponent() {
  return <Dashboard />;
}
